import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useActionCardStyles = makeStyles(
  (theme: Theme) => {
    const isDark = theme.palette?.mode === 'dark';

    return {
      cardContainer: {
        display: 'flex',
        padding: '1rem',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '1rem',
        borderRadius: '0.5rem',
        background: isDark ? '#4D4D4D' : 'var(--xlrt-color-ui-gray90)',
      },
      contentContainer: {
        display: 'flex',
        width: '76%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '0.75rem',
      },
      cardTitle: {
        fontSize: '1.125rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        color:
          theme.palette?.mode === 'dark'
            ? 'var(--xlrt-color-ui-white)'
            : 'var(--xlrt-color-ui-gray20)',
      },
      cardDescription: {
        fontSize: '.875rem',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '155%',
        color: isDark
          ? 'var(--xlrt-color-ui-gray75)'
          : 'var( --xlrt-color-ui-gray45)',
      },
      cardAction: {
        fontSize: '.875rem',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '160.714%',
        color: isDark
          ? 'var(--xlrt-color-future-green500)'
          : 'var(--xlrt-color-future-green800)',
        cursor: 'pointer',
      },
    };
  },
  { name: 'ActionCard' },
);
